/* ── Semantic Design Tokens — H2 Strategy B foundation ── */
//
// PURPOSE
//   Establishes a semantic CSS custom-property vocabulary (surface / text /
//   border / accent / status) that future migration PRs will point
//   (shadows already live in dark-mode-css.js — not duplicated here to avoid a
//   --shadow-* name collision flagged in PR #406 review)
//   STATUS_COLORS, dark-mode tables, and inline styles at — one canonical
//   source of truth for the palette instead of ~4000 scattered hex literals.
//
// ZERO-VISUAL CONTRACT (this PR)
//   This module ONLY *defines* the variables. Nothing references them yet, so
//   adding ~30 unused custom properties to the cascade changes no pixel
//   anywhere. Migration of consumers happens in subsequent PRs.
//
// DARK-MODE SELECTOR — why `.dark-mode` (bare class), not `:root.dark-mode`
//   Dark mode is toggled by a `.dark-mode` class placed on a *wrapper <div>*
//   (App.jsx render: `<div className={dark ? "dark-mode" : ""}>`), NOT on the
//   <html>/:root element. `dark-mode-css.js` follows the same convention — its
//   dark rules are all `.dark-mode <selector>`. So the dark overrides here use
//   the bare `.dark-mode` selector: the class matches the wrapper div, and the
//   overridden values cascade down to every descendant. `:root.dark-mode`
//   would NEVER match (the class is not on :root), so the dark values would
//   silently never apply. Matching the existing mechanism keeps a future
//   migration zero-visual.
//
// Light values live in :root; the dark block overrides only the tokens that
// differ in dark theme (the rest inherit the :root light value unchanged).
export const designTokens = `
  :root {
    --surface-page:#FFFFFF; --surface-card:#FFFFFF; --surface-sunken:#F8FAFC; --surface-hover:#F1F5F9;
    --text-primary:#0F172A; --text-secondary:#475569; --text-tertiary:#94A3B8; --text-muted:#CBD5E1; --text-inverse:#FFFFFF;
    --border-subtle:#F1F5F9; --border-default:#E2E8F0; --border-strong:#CBD5E1;
    --accent:#6366F1; --accent-soft:#EEF2FF;
    --status-success:#10B981; --status-success-soft:#ECFDF5; --status-success-text:#065F46;
    --status-warn:#F59E0B; --status-warn-soft:#FEF3C7; --status-warn-text:#92400E;
    --status-error:#EF4444; --status-error-soft:#FFF1F2; --status-error-text:#9F1239;
    --status-info:#3B82F6; --status-info-soft:#EFF6FF; --status-info-text:#1D4ED8;
    --status-neutral:#818CF8; --status-neutral-soft:#EEF2FF; --status-neutral-text:#FFFFFF;
  }

  .dark-mode {
    --surface-page:#0F172A; --surface-card:#1E293B; --surface-sunken:#0F172A; --surface-hover:#334155;
    --text-primary:#F1F5F9; --text-secondary:#CBD5E1; --text-tertiary:#94A3B8; --text-muted:#64748B;
    --border-subtle:#1E293B; --border-default:#334155; --border-strong:#475569;
    --status-success-soft:#064E3B; --status-warn-soft:#78350F; --status-error-soft:#7F1D1D; --status-info-soft:#1E3A8A;
  }
`;
